import { Col, Drawer, Row, Modal } from 'antd';
import { MinusOutlined, PlusOutlined, CloseOutlined } from '@ant-design/icons';
import { Heading } from 'components/Typography';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button } from 'components/Button';
import ConfirmLeaveEdit from './confirmLeaveEdit';
import { editLeaveInProfile, getLeavesData  } from 'actions/userManagementV3';

const EditLeaveDrawer = ({ visible, onClose, leaveDetails_V3, user, editLeaveInProfile,getLeavesData , fromWhere, userRowDetails }) => {
    const [loader, setLoader] = useState(false);
    const [availableLeaves, setAvailableLeaves] = useState([]);
    const [confirmVisible, setConfirmVisible] = useState(false); // State for the confirm modal visibility
console.log("userdata",userRowDetails);
    useEffect(() => {
        const temp = leaveDetails_V3?.leaveTypesForUser?.map(item => ({ ...item })) || [];
        setAvailableLeaves(temp);
        return () => {
            setAvailableLeaves([]);
        };
    }, [leaveDetails_V3]);

    const hasLeavesChanged = React.useMemo(() => {
        const initialLeaves = leaveDetails_V3?.leaveTypesForUser || [];
        if (!initialLeaves.length || !availableLeaves.length) return false;
        return availableLeaves.some((leave, index) => {
            const initial = initialLeaves[index];
            return Number(leave?.remaining) !== Number(initial?.remaining);
        });
    }, [availableLeaves, leaveDetails_V3?.leaveTypesForUser]);

    const handleOnChange = (index, key, value) => {
        availableLeaves[index][key] = parseInt(value);
        setAvailableLeaves([...availableLeaves]);
    };

    const handleSaveClick = () => {
        if (!hasLeavesChanged) return;
        setConfirmVisible(true); // Show the confirm modal
    };

    const handleConfirm = () => {
        const params = {
            // userId: fromWhere === 'userManagementProfile' ? userRowDetails?.id : user.id,
            userId: userRowDetails?.id,
            leaveTypes: availableLeaves?.map((leave) => ({
                leaveType: leave?.leaveType,
                noOfLeaves: leave?.remaining,
                availed: leave?.availed,
            })),
        };
        setLoader(true);
        editLeaveInProfile(params, () => {
            setLoader(false);
            setConfirmVisible(false);
            onClose();
        }, () => {
                getLeavesData({ userId: userRowDetails?.id }, () => {});
                onClose();
        }, () => {});
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    return (
        <>
            <Drawer
                visible={visible}
                onClose={onClose}
                width={'35%'} // Adjust the width as needed
                placement="right" // Opens the drawer from the right side
                destroyOnClose={true}
                bodyStyle={{ 
                    padding: 0, 
                    overflow: 'hidden',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                }}
                closable={false} // Hides the default close button
                closeIcon={
                    <CloseOutlined style={{position: 'absolute',top: '16px',right: '16px',fontSize: '16px',}}/>
                  }
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px 10px 20px'}}>
                    <Heading level={3}>Edit leaves</Heading>
                    <CloseOutlined 
                        onClick={onClose} 
                        style={{ fontSize: 20, color: '#AEAEAE', cursor: 'pointer' }} 
                    />
                </div>

                <div style={{ height: "calc(100vh - 150px)", overflowY: 'auto', padding: '10px 20px' }}>
                    {availableLeaves?.map((leave, index) => (
                        <div key={index}>
                            <div className='r-jsb'>
                                <div style={{ fontSize: 16, }} className='color-black bold-400 '>{leave.leaveType} Leave</div>
                                <div style={{color:'#AEAEAE', fontSize: 13, fontWeight: 400 }}>From {formatDate(leave.startDate)} to {formatDate(leave.endDate)}</div>
                            </div>
                            <Row gutter={16} align="middle" style={{ height:'15%',marginBottom: '24px', marginTop: '14px', paddingBottom: '24px',borderBottom: index < availableLeaves.length - 1 ? '1px solid #E0E0E0' : 'none' }}>
                                <Col span={8} style={{ borderRight: '1px solid #E0E0E0' }}>
                                    <div className='r-jsb' style={{ width: "70%" }}>
                                        <div className='simgrey'>Availed</div>
                                        <div style={{color: "#636363",fontSize: 14, fontWeight: 500}}>{leave.availed}</div>
                                    </div>
                                </Col>
                                <Col span={8} >
                                    <div style={{ textAlign: 'center'}}>
                                        <span style={{color: "#636363"}}>Balance</span>
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <Button
                                            type="link"
                                            icon={<MinusOutlined style={{ color: '#FF414D', fontSize: 20 }} />}
                                            style={{ padding: 0, lineHeight: 1 }}
                                            onClick={() => handleOnChange(index, 'remaining', Math.max(leave.remaining - 1, 0))}
                                        />
                                        <span style={{ width:'30%',textAlign:'center',fontSize: 14, fontWeight: 500,color: "#636363", borderBottom:'1px solid #AEAEAE'}}>
                                            {leave?.remaining.toString().padStart(2, '0')}
                                        </span>
                                        <Button
                                            type="link"
                                            icon={<PlusOutlined style={{ color: '#2EA083', fontSize: 20 }} />}
                                            style={{ padding: 0, lineHeight: 1 }}
                                            onClick={() => handleOnChange(index, 'remaining', leave.remaining + 1)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </div>

                <div className='r-c-c m-t-20' style={{ display: 'flex', justifyContent: 'space-between', padding: '20px'}}>
                    <Button onClick={onClose} >
                        CANCEL
                    </Button>
                    <Button
                        type="primary"
                        onClick={!hasLeavesChanged || loader ? undefined : handleSaveClick}
                        loading={loader}
                        disabled={!hasLeavesChanged || loader}
                        style={{
                            opacity: !hasLeavesChanged ? 0.5 : 1,
                            cursor: !hasLeavesChanged ? 'not-allowed' : 'pointer',
                        }}
                    >
                        SAVE
                    </Button>
                </div>
            </Drawer>

            <ConfirmLeaveEdit
                visible={confirmVisible}
                onClose={() => setConfirmVisible(false)}
                onDelete={handleConfirm}
                deleteLoader={loader}
            />
        </>
    );
};

const mapStateToProps = (state) => {
    const { user } = state.session;
    const { leaveDetails_V3 } = state.userManagementV3;
    const { userRowDetails } = state.userManagementV2;
    return {
        leaveDetails_V3, user, userRowDetails
    };
};

const mapDispatchToProps = (dispatch) => ({
    editLeaveInProfile: (params, callback, successCallBack, pagecallback) => dispatch(editLeaveInProfile(params, callback, successCallBack, pagecallback)),
    getLeavesData: (params, callback) => dispatch(getLeavesData(params, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditLeaveDrawer);
